export default {
  // GET Requests //

  // Gets all forms
  async getForms(context) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let forms;
    let submissions;

    try {
      forms = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/forms/retrieve-by-company/" +
          companyId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      forms = await forms.json();

      submissions = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/form-submissions/retrieve-by-company/" +
          companyId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      submissions = await submissions.json();
    } catch (err) {
      return 500;
    }

    for (let i = 0; i < forms.forms.length; i++) {
      forms.forms[i].formId = forms.forms[i]._id;
    }

    let submissionsPayload = [];
    for (let i = 0; i < submissions.submissions.length; i++) {
      for (let j = 0; j < submissions.submissions[i].submissions.length; j++) {
        submissionsPayload.push({
          formId: submissions.submissions[i].formId,
          userId: submissions.submissions[i].userId,
          responses: submissions.submissions[i].submissions[j].responses,
          datetime: submissions.submissions[i].submissions[j].datetime,
        });
      }
    }

    context.commit("forms", forms.forms);
    context.commit("submissions", submissionsPayload);
    context.commit("formsTimestamp");

    return 200;
  },
  // POST Requests //

  // Create a form
  async postForm(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(process.env.VUE_APP_NODE_SERVER + "/forms/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          companyId: companyId,
          formName: payload.formName,
          description: payload.description,
          recipients: payload.recipients,
          type: payload.type,
          frequency: payload.frequency,
          days: payload.days,
          triggerTime: payload.triggerTime,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          audience: payload.auidence,
          departments: payload.departments,
          locations: payload.locations,
          group: payload.group,
          anonymous: payload.anonymous,
          fields: payload.fields,
          points: payload.points,
        }),
      });
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    response.form.formId = response.form._id;

    let formsPayload = context.state.forms;
    formsPayload.push(response.form);

    context.commit("forms", formsPayload);

    return {
      status: 201,
      formId: response.form.formId,
    };
  },

  // PATCH Requests //

  // Update a form
  async patchForm(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    console.log(Intl.DateTimeFormat().resolvedOptions().timeZone);

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/forms/update",
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            formId: payload.formId,
            formName: payload.formName,
            description: payload.description,
            recipients: payload.recipients,
            type: payload.type,
            frequency: payload.frequency,
            days: payload.days,
            triggerTime: payload.triggerTime,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            audience: payload.auidence,
            departments: payload.departments,
            locations: payload.locations,
            group: payload.group,
            anonymous: payload.anonymous,
            fields: payload.fields,
            points: payload.points,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    response.form.formId = response.form._id;

    let formsPayload = context.state.forms;
    for (let i = 0; i < formsPayload.length; i++) {
      if (formsPayload[i].formId == response.form.formId) {
        formsPayload[i] = response.form;
        break;
      }
    }

    context.commit("forms", formsPayload);

    return {
      status: 200,
      formId: response.form.formId,
    };
  },

  // DELETE Requests //

  // Remove a form
  async deleteForm(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];

    try {
      await fetch(process.env.VUE_APP_NODE_SERVER + "/forms/remove", {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          companyId: companyId,
          formId: payload.formId,
        }),
      });
    } catch (err) {
      return { status: 500 };
    }

    let formsPayload = context.state.forms;
    formsPayload.filter((form) => form.formId != payload.formId);

    let submissionsPayload = context.state.submissions;
    submissionsPayload.filter((sub) => sub.formId != payload.formId);

    context.commit("forms", formsPayload);
    context.commit("submissions", submissionsPayload);

    return {
      status: 201,
    };
  },

  // Reset form timestamp
  formsTimestampReset(context) {
    context.commit("formsTimestampReset");
  },
};
